import classNames from 'classnames';
import { FC } from 'react';

const Dot: FC<{ className?: string }> = ({ className }) => {
  return (
    <span
      className={classNames('bg-red-500 h-2.5 w-2.5 rounded-full', className)}
    />
  );
};

export default Dot;
